module.exports = __webpack_public_path__ + "static/media/IconoCompetenciasEspecificas.4d739b3c.svg";